import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const products = [
  {
    id: 1,
    img1: "assets/images/product/medium-size/1-1.jpg",
    img2: "assets/images/product/medium-size/1-2.jpg",
    title: "Pendant, Made of White Pl...",
    newPrice: "£120.80",
    oldPrice: "",
    badge: "New",
    rating: 4,
  },
  {
    id: 2,
    img1: "assets/images/product/medium-size/1-3.jpg",
    img2: "assets/images/product/medium-size/1-4.jpg",
    title: "Swirl 1 Medium Pendant La...",
    newPrice: "£120.80",
    oldPrice: "",
    badge: "New",
    rating: 3,
  },
  {
    id: 3,
    img1: "assets/images/product/medium-size/1-5.jpg",
    img2: "assets/images/product/medium-size/1-6.jpg",
    title: "Work Lamp Silver Proin he...",
    newPrice: "£135.20",
    oldPrice: "",
    badge: "Sale",
    rating: 2,
  },
  {
    id: 4,
    img1: "assets/images/product/medium-size/1-7.jpg",
    img2: "assets/images/product/medium-size/1-8.jpg",
    title: "Work Lamp Silver Proin he...",
    newPrice: "£135.20",
    oldPrice: "",
    badge: "New",
    rating: 5,
  },
  {
    id: 5,
    img1: "assets/images/product/medium-size/1-9.jpg",
    img2: "assets/images/product/medium-size/1-1.jpg",
    title: "Vitra Sunburst Clock pret...",
    newPrice: "£1199.60",
    oldPrice: "",
    badge: "Sale",
    rating: 4,
  },
  {
    id: 6,
    img1: "assets/images/product/medium-size/1-2.jpg",
    img2: "assets/images/product/medium-size/1-9.jpg",
    title: "Light Inverted Pendant Qu...",
    newPrice: "£110.00",
    oldPrice: "£130.00",
    badge: "New",
    rating: 5,
  },
];

const RelatedProduct = () => {
  return (
    <div className="hiraola-product_area hiraola-product_area-2">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="hiraola-section_title">
              <h4>Related Products</h4>
            </div>
          </div>

          <div className="col-lg-12">
            <Swiper
              modules={[Navigation]}
            //   navigation
              loop
              spaceBetween={30}
              slidesPerView={4}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                // 992: { slidesPerView: 4 },
              }}
              className="hiraola-product_slider-3"
            >
              {products.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="single_product">
                    <div className="product-img">
                      <a href="single-product.html">
                        <img className="primary-img" src={item.img1} alt="" />
                        <img className="secondary-img" src={item.img2} alt="" />
                      </a>

                      <span
                        className={
                          item.badge === "Sale" ? "sticker-2" : "sticker"
                        }
                      >
                        {item.badge}
                      </span>

                      {/* ACTION BUTTONS */}
                      <div className="add-actions">
                        <ul>
                          <li>
                            <a
                              className="hiraola-add_cart"
                              href="cart.html"
                              title="Add To Cart"
                            >
                              <i className="ion-bag"></i>
                            </a>
                          </li>
                          <li>
                            <a
                              className="hiraola-add_compare"
                              href="compare.html"
                              title="Compare"
                            >
                              <i className="ion-ios-shuffle-strong"></i>
                            </a>
                          </li>
                          <li className="quick-view-btn">
                            <a
                              href="#!"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModalCenter"
                              title="Quick View"
                            >
                              <i className="ion-eye"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="hiraola-product_content" style={{textAlign: "left",  padding: "0 20px 20px"}}>
                      <div className="product-desc_info">
                         <div className="content-left">
                        <h6>
                          <a href="single-product.html">{item.title}</a>
                        </h6>

                        {/* PRICE */}
                      
                        <div className="price-box d-flex">
                          <span className="new-price">{item.newPrice}</span>
                          {item.oldPrice && (
                            <span className="old-price">
                              {item.oldPrice}
                            </span>
                          )}
                       

                        {/* WISHLIST */}
                        <div className="additional-add_action">
                          <ul>
                            <li>
                              <a
                                className="hiraola-add_compare"
                                href="wishlist.html"
                                title="Add To Wishlist" 
                              >
                                <i className="ion-android-favorite-outline"style={{marginLeft: "200px"}} ></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                     </div>
                        {/* RATING */}
                        <div className="rating-box">
                          <ul>
                            {[1, 2, 3, 4, 5].map((star) => (
                              <li
                                key={star}
                                className={
                                  star > item.rating ? "silver-color" : ""
                                }
                              >
                                <i className="fa fa-star-of-david"></i>
                              </li>
                            ))}
                          </ul>
                        </div>
                       </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedProduct;
